import React from 'react';
import InvestmentMetric from './InvestmentMetric';
import { checkCondition } from '../formBuilder/utility/filterSchema';
import investmentCriteriaDefaults from '../../constants/investmentCriteria';
import { isValue } from '../../utility/isValue';
import Tooltip from '../Tooltip';
import { getResult } from './helpers';
import classNames from 'classnames';

export default function InvestmentMetrics({
  schema,
  data,
  type = 'report',
  disabled,
}) {
  if (!schema || !data) return null;
  const filteredSchema = schema?.filter((field) => {
    if (!field.condition) return true;
    if (!Array.isArray(field.condition)) {
      const value = data[field.condition.field];
      if (
        !isValue(value) &&
        investmentCriteriaDefaults[field.condition.field]
      ) {
        return true;
      }
    } else {
      return field.condition.every((option) => {
        const value = data[option.field];

        if (!isValue(value) && investmentCriteriaDefaults[option.field]) {
          return true;
        }
      });
    }
    return checkCondition(field.condition, data);
  });

  const results = filteredSchema?.map((field) => getResult(field, data)) || [];
  const sortedResults = [...results].sort((a, b) => b?.value - a?.value);

  const percentagePassed =
    disabled || !results.length
      ? '-'
      : `${
          Math.round(
            (results.filter((result) => result?.value === 1).length /
              results.length) *
              10000
          ) / 100
        }%`;

  const tooltipText =
    'You can customize your investment criteria in the "Criteria" page.';

  if (!filteredSchema || !filteredSchema.length) return null;

  return (
    <>
      {type === 'overview' && (
        <>
          <div className="grid grid-cols-[10px_10px_10px_10px_10px] min-h-[24px] gap-1">
            {sortedResults.map((result, index) => (
              <div
                key={index}
                className={classNames(
                  'rounded-[3px] w-full h-[10px]',
                  disabled
                    ? 'bg-neutral-100'
                    : result?.value === 1
                    ? 'bg-primary-500'
                    : 'bg-primary-500 opacity-25'
                )}
              ></div>
            ))}
          </div>
          <div className="flex flex-col">
            <span className="text-base text-neutral-500">
              Investment Criteria
            </span>
            <span
              className={classNames(
                'text-lg font-medium',
                disabled ? 'text-neutral-500' : 'text-neutral-900'
              )}
            >
              {percentagePassed}
            </span>
          </div>
        </>
      )}
      {type === 'report' && (
        <section id="investment-criteria" className="w-full mt-7 ">
          <h2 className=" w-full tracking-wider text-lg font-medium text-neutral-900 pb-3">
            <span className="px-3 py-1">{'Investment Criteria'}</span>
          </h2>
          <div className="w-full flex gap-4 flex-wrap justify-around bg-white p-2 pt-3 rounded-lg relative">
            <div className="absolute top-0 left-1">
              <Tooltip
                type="info"
                heading="Investment Criteria"
                text={tooltipText}
              />
            </div>
            {filteredSchema?.map((field, index) => (
              <InvestmentMetric
                key={field.name + index}
                field={field}
                data={data}
                result={results[index]}
              />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
